<div class="kiosk-preloader">
  <div class="kiosk-preloader-container">
    <div class="kiosk-preloader-container__spinner">
      <div class="store-container">
        <div class="border-animation">
          <div class="kiosk-preloader-container__content">
            <div class="kiosk-preloader-container__content-title">Loading your cart...</div>
            <app-spinner></app-spinner>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


